export class PracticeExam {
  id: string;
  date: Date;
  isSuccess: boolean;
  disqualifyingFaults: number;
  totalScore: number;
  maxScore: number;

  constructor(obj: Partial<PracticeExam>) {
    this.id = obj.id || '';
    this.date = obj.date || null;
    this.isSuccess = obj.isSuccess || false;
    this.disqualifyingFaults = obj.disqualifyingFaults || 0;
    this.totalScore = obj.totalScore || 0;
    this.maxScore = obj.maxScore || 0;
  }

  get result(): 'Réussite' | 'Échec' {
    return this.isSuccess ? 'Réussite' : 'Échec';
  }

  get color(): 'accent-4' | 'error-3' {
    return this.isSuccess ? 'accent-4' : 'error-3';
  }
}

export class PracticeExamDetails extends PracticeExam {
  examResult: ExamResult;
  examState: ExamState;
  teacherComments: string | null;
  teacherName: string;
  drivingSkillsSorted: DrivingSkillCategory[];

  constructor(obj: Partial<PracticeExamDetails>) {
    super(obj);
    this.examResult = obj.examResult || { score: 0, max: 0, success: false, disqualifyingErrors: 0 };
    this.examState = obj.examState || { result: '', icon: '', color: '' };
    this.teacherComments = obj.teacherComments || null;
    this.teacherName = obj.teacherName;
    this.drivingSkillsSorted = obj.drivingSkillsSorted || [];
  }
}

export type DrivingSkill = {
  label: string;
  maxGrade: number;
  grade: number | string;
  color: string;
  state: string;
};

export type DrivingSkillCategory = {
  category: string;
  subSkills: DrivingSkill[];
};

export type ExamResult = {
  score: number;
  max: number;
  success: boolean;
  disqualifyingErrors: number;
};

export type ExamState = {
  result: string;
  icon: string;
  color: string;
};
